import { TranslationManager } from './TranslationManager';

// This will match any JSON file in any _translations directory and direct JSON files in src/translations
const translationContext = (require as any).context('../', true, /(_translations\/.*\.json$|translations\/.*\.json$)/);

export function loadAllTranslations() {
  const manager = TranslationManager.getInstance();
  
  // Get all translation files
  const translationFiles: string[] = translationContext.keys();
  
  // Register each translation file
  translationFiles.forEach((filePath: string) => {
    const translations = translationContext(filePath);
    manager.registerTranslations(translations);
  });
} 